<div [formGroup]="populationForm">
  <div formArrayName="criteria">
    <div [formGroupName]="index">
      <gp-tree-select class="form-control"
                      [attr.test-id]="'create-population-' + criterion?.zoneID +'-tree-select'"
                      [url]="criterion?.metadatas?.rel"
                      [tree] = "tree"
                      [responseCallBack]="responseCallback"
                      [lazyValue]="lazyValue"
                      formControlName="criterionValue"
                      [isSorted]="true"
                      (elementSelected)="onEntitySelected($event)"
                      ngDefaultControl>
      </gp-tree-select>
    </div>
  </div>
</div>

